export default {"src":"/_next/static/media/heart-fill.491b00b3.svg","height":968,"width":968,"blurWidth":0,"blurHeight":0};